import { render, staticRenderFns } from "./ActionField.vue?vue&type=template&id=87f03260&scoped=true"
import script from "./ActionField.vue?vue&type=script&lang=js"
export * from "./ActionField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f03260",
  null
  
)

export default component.exports